import SignUpService from 'pages/signup/services/signup.service';

// utils/userTracking.ts

export const userTrackFunction = async (
  userIdSub: string,
  utmParameters: any,
  utmParamsdata?:any
) => {
  try {
    const utmdata: any = JSON.parse(localStorage.getItem('utmData') || '{}');
    if (utmdata?.utmCampaign || utmdata?.utmMedium || utmdata?.utmSource) {
      const response = await SignUpService.userTracking({
        ...utmdata,
        userId: userIdSub,
        payload: JSON.stringify(utmParameters),
        slug: utmParamsdata?.method
      });

      console.log('User tracking successful:', response);
      return response; // Optionally return the response if needed
    } else {
      // console.log('No UTM data found in localStorage');
    }
  } catch (err: any) {
    console.error('Error in user tracking:', err);
  }
};

// utils/utmHandler.ts

export const handleUtmAndReferral = (
  location: Location,
  setUtmParameters?: (params: any) => void
) => {
  const utmParams: any = new URLSearchParams(location.search);
  if (utmParams.size) {
    const queryObject: any = {};
    utmParams.forEach((value, key) => {
      queryObject[key] = value;
    });

    const data = {
      utmSource: utmParams.get('utm_source'),
      utmMedium: utmParams.get('utm_medium'),
      utmCampaign: utmParams.get('utm_campaign'),
    };

    if (setUtmParameters) {
      setUtmParameters(queryObject);
    }
    localStorage.setItem('utmData', JSON.stringify(data));
  }
};
